module.exports = __webpack_public_path__ + "img/artless-logo-blanco.fa8e429c.svg";